import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=684a5708&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=684a5708&prod&scoped=true&lang=css"
import style1 from "./Index.vue?vue&type=style&index=1&id=684a5708&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a5708",
  null
  
)

export default component.exports